import React, { useState, useEffect, useContext, useRef } from "react";
import "../Resume-Upload/ResumeUpload.css";
// import trash from "../../Assets/Images/delete-active-icon.png";
import viewResumeIcon from "../../Assets/Images/resume-view.png";
import viewCandidateIcon from "../../Assets/Images/candidate-view.png";
import Table from "../../Common/Table/Table";
import DynamicSkeleton from "../../Common/Skeleton/Skeleton";
import allFilesIcon from "../../Assets/Images/All-Files-Icon.png";
import allFilesDarkIcon from "../../Assets/Images/All-Files-Dark-Icon.png";
import ParsedFilesIcon from "../../Assets/Images/parsed-icon.png";
import failedFilesIcon from "../../Assets/Images/failed-icon.png";
import runningFilesIcon from "../../Assets/Images/Running-Status-Icon.png";
import IncompleteIcon from "../../Assets/Images/incomplete-icon.png";
import uploadIcon from "../../Assets/Images/resume-upload-icon.png";
import Button from "../../Common/Button/Button";
import CustomTooltip from "../../Common/Tooltip/Tooltip";
import DotLoader from "../../Common/Pre-Loader/DotLoader.jsx";
import BorderLinearProgressBar from "../../Common/Border-linear-process/BorderLinearProgress.js";
import RPHeaderDarkIcon from "../../Assets/Images/RP Page Header Icon - Dark.svg";
import RPHeaderLightIcon from "../../Assets/Images/RP Page Header Icon - Light.svg";
import FileIcon from "../../Common/Common-Function/IconMapping.js";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar.js";
import SidePopup from "../../Common/SidePopup/SidePopup.js";
import { formatDate } from "../../Common/Common-Function/CommonFunctions.js";
import { DynamicContext } from "../../Context/DynamicContext.js";
import DeleteConfirmation from "../../Common/Delete-Confirmation/DeleteConfirmation.js";
import DynamicAutocomplete from "../../Common/AutoSuggestion/DynamicAutocomplete";
import { get, post } from "../../helper/Api_helper.js";
import {
  VYLABS_BASE_URL,
  GET_CANDIDATE_BY_ID,
  CCREATE_CAN,
  VENDORS_SEARCH,
  GET_VENDOR_DETAILS_BY_ID,
  UPDATE_CANDIDATE_DETAILS,
  GET_RESUME_PRESIGNED_URL,
  SEND_FEEDBACK,
} from "../../helper/url_helper.js";
import CandidateDetailsContainer from "../../Common/Candidate-Details-Container/CandidateDetailsContainer.js";
import ResumeViewerModal from "../Applicant-Tracking/Candidates/CandidateDetails/ResumeViewerModal.js";
import { useFormik } from "formik";
import * as Yup from "yup";
import DynamicTextField from "../../Common/Textfield/Textfield.js";
import AutoComplete from "../../Common/AutoComplete/AutoComplete";
import PhoneNumberInput from "../../Common/PhoneNumberInput/PhoneNumberInput";
import OptionsData from "../../Assets/Json/StaticOptions.json";
import ResumeViewer from "../../Common/Resume-Viewer/ResumeViewer.js";

const { StaticOptions = {} } = OptionsData || {};
const { skills = [] } = StaticOptions || {};

function ResumeParser(props) {
  const {
    isDarkMode,
    triggerWebSocketReset,
    setShowResumeParser,
    isParsingComplete,
    setIsParsingComplete,
    incompleteFiles,
    setIncompleteFiles,
    isVendorFeatureEnabled,
    userDetails,
    tenantDetails,
  } = useContext(DynamicContext);
  const {
    UploadedResumes,
    isLoading,
    parsedData,
    setUploadedResumes,
    errorMessages,
    parsedFiles,
    failedFiles,
    showHeader,
    incompleteData,
    setParsedFiles,
    setFailedFiles,
    showFailedTab,
    setParsedData,
    setIncompleteData,
    setRunSetId,
    setErrorMessages,
    setSuccessMessages,
    setShowFailedTab,
    handleRetryAllFailed,
    retryApiResponses,
    failedFileRetryCounts = {},
  } = props || {};
  const BUTTON_USAGE_KEY = "resume_parser_button_usage";
  const [filterStatus, setFilterStatus] = useState("All");
  const [progressData, setProgressData] = useState({});
  const maxProgressRef = useRef({});
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [hasSearched, setHasSearched] = useState(true);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");
  const [resumeName, setResumeName] = useState("");
  const [candidateModal, setCandidateModal] = useState(false);
  const [autoCompleteKey, setAutoCompleteKey] = useState(0);
  const [selectedIncompleteFileId, setSelectedIncompleteFileId] =
    useState(null);
  const [vendorList, setVendorList] = useState([]);
  const [vendorOptionLoading, setVendorOptionLoading] = useState(false);
  const [assignedVendor, setAssignedVendor] = useState(null);
  const [isEditingCandidate, setIsEditingCandidate] = useState(false);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [editedCandidateData, setEditedCandidateData] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const [allCanList, setAllCanList] = useState([]);
  const [isAllCandidatesActive, setIsAllCandidatesActive] = useState(true);
  const [myCanList, setMyCanList] = useState([]);
  const [retryButtonUsed, setRetryButtonUsed] = useState(false);
  const [reportButtonUsed, setReportButtonUsed] = useState(false);
  const formik = useFormik({
    initialValues: {
      canName: "",
      canEmail: "",
      canLocation: "",
      canMobile: "",
      canSkills: "",
      secondaryPhone: "",
      secondaryEmail: "",
      jobDescription: "",
      askmeanything: "",
      designation: "",
      vendorID: "",
    },
    validationSchema: Yup.object({
      canName: Yup.string().required("Candidate Name is required"),
      canEmail: Yup.string()
        .email("Invalid email format")
        .test(
          "email-or-phone",
          "Either Email or Phone Number is required",
          function (value) {
            const { canMobile } = this.parent;
            if (!value && !canMobile) {
              return false;
            }
            return true;
          },
        ),
      canMobile: Yup.string()
        .matches(/^\+?[0-9]+$/, "Only digits are allowed")
        .min(10, "Must be at least 10 digits")
        .test(
          "phone-or-email",
          "Either Email or Phone Number is required",
          function (value) {
            const { canEmail } = this.parent;
            if (!value && !canEmail) {
              return false;
            }
            return true;
          },
        ),
      secondaryPhone: Yup.string()
        .matches(/^[0-9]+$/, "Only digits are allowed")
        .min(10, "Must be at least 10 digits"),
      secondaryEmail: Yup.string(),
      skills: Yup.array()
        .min(1, "At least one skill is required")
        .required("Skills are required"),
      jobDescription: Yup.string(),
      askmeanything: Yup.string(),
      designation: Yup.string(),
    }),
  });
  const fetchVendors = async (inputValue = "") => {
    try {
      setVendorOptionLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${VENDORS_SEARCH}?vendor_name=${encodeURIComponent(inputValue)}`,
      );

      const { vendors = [] } = response;
      const fetchedVendors = Array.isArray(vendors)
        ? vendors
            .filter((v) => v?.id && v?.name)
            .map((v) => ({
              label: v.contact_person
                ? `${v.name} - ${v.contact_person}`
                : v.name,
              value: v.id,
            }))
        : [];

      setVendorList(fetchedVendors);
    } catch (err) {
      console.error("fetchVendors error", err);
      setVendorList([]);
    } finally {
      setVendorOptionLoading(false);
    }
  };

  const handleVendorInputChange = (_, value) => {
    if (value && value.length >= 3) {
      fetchVendors(value);
    } else {
      setVendorList([]);
    }
  };

  const fetchCandidateById = React.useCallback(
    async (id, actionType, fileData = null) => {
      if (fileData && actionType === "viewResume") {
        try {
          const presignedUrlResponse = await getFreshPresignedUrl(
            id,
            fileData.file_id || null,
          );

          const finalUrl = presignedUrlResponse?.presigned_url;
          if (finalUrl) {
            setResumeName(fileData.name);
            setResumeUrl(finalUrl);
            setShowResumeModal(true);
          } else if (fileData.presigned_url) {
            setResumeName(fileData.name);
            setResumeUrl(fileData.presigned_url);
            setShowResumeModal(true);
          } else {
            Toast("error", "Unable to load resume.");
          }
        } catch (error) {
          console.error("Error fetching presigned URL:", error);
          if (fileData.presigned_url) {
            setResumeName(fileData.name);
            setResumeUrl(fileData.presigned_url);
            setShowResumeModal(true);
          } else {
            Toast("error", "Failed to load resume.");
          }
        }
      } else if (fileData && actionType === "viewCandidate") {
        try {
          const res = await get(
            VYLABS_BASE_URL,
            `${GET_CANDIDATE_BY_ID}?id=${id}`,
          );
          const candidate = res?.candidate;
          const candidateFiles = res?.files;
          const parsedResumeData = candidate?.parsed_resume
            ? JSON.parse(candidate.parsed_resume)
            : null;
          const presignedUrl =
            candidateFiles && candidateFiles.length > 0
              ? candidateFiles[0].presigned_url
              : null;
          // let vendorDetails = null;

          const updatedCandidate = {
            ...candidate,
            secondaryEmail: candidate.secondary_email,
            secondaryPhone: candidate.secondary_phone,
            vendorID: candidate.vendor_id,
            lineAddress1: candidate.line_address_1,
            lineAddress2: candidate.line_address_2,
            preferredSalary: candidate.preferred_salary,
            zipCode: candidate.zip_code,
            parsedResumeData,
            files: candidateFiles || null,
            presignedUrl,
            isFileBased: false,
            avatar: res?.profile_img_url,
          };

          if (updatedCandidate.vendor_id) {
            try {
              const vendorResponse = await get(
                VYLABS_BASE_URL,
                `${GET_VENDOR_DETAILS_BY_ID}?id=${updatedCandidate.vendor_id}`,
              );
              setAssignedVendor(vendorResponse);
              updatedCandidate.vendorDetails = vendorResponse || null;
            } catch (err) {
              console.error("Error fetching vendor details:", err);
              updatedCandidate.vendorDetails = null;
            }
          } else {
            updatedCandidate.vendorDetails = null;
          }
          setSelectedCandidate(updatedCandidate);
          setIsModalOpen(true);
        } catch (error) {
          console.error("Error fetching candidate:", error);
        }
      } else {
        try {
          const res = await get(
            VYLABS_BASE_URL,
            `${GET_CANDIDATE_BY_ID}?id=${id}`,
          );
          const candidate = res?.candidate;
          const candidateFiles = res?.files;
          const parsedResumeData = candidate?.parsed_resume
            ? JSON.parse(candidate.parsed_resume)
            : null;
          const presignedUrl =
            candidateFiles && candidateFiles.length > 0
              ? candidateFiles[0].presigned_url
              : null;
          let vendorDetails = null;
          if (candidate.vendor_id) {
            try {
              const vendorResponse = await get(
                VYLABS_BASE_URL,
                `${GET_VENDOR_DETAILS_BY_ID}?id=${candidate.vendor_id}`,
              );
              setAssignedVendor(vendorResponse);
              vendorDetails = vendorResponse || null;
            } catch (err) {
              console.error("Error fetching vendor details:", err);
              vendorDetails = null;
            }
          }
          if (actionType === "viewCandidate") {
            setSelectedCandidate({
              ...candidate,
              parsedResumeData,
              files: candidateFiles,
              presignedUrl,
              isFileBased: false,
              avatar: res?.profile_img_url,
              vendorDetails: vendorDetails,
            });
            setIsModalOpen(true);
          } else if (actionType === "viewResume") {
            if (candidateFiles && candidateFiles.length > 0) {
              setResumeName(candidateFiles[0].name);
              setResumeUrl(candidateFiles[0].presigned_url);
              setShowResumeModal(true);
            } else {
              console.error("No resume file found for this candidate.");
            }
          }
        } catch (error) {
          console.error("Error fetching candidate:", error);
        }
      }
    },
    [
      setResumeName,
      setResumeUrl,
      setShowResumeModal,
      setSelectedCandidate,
      setIsModalOpen,
    ],
  );

  const getFreshPresignedUrl = async (candidateId, fileId = null) => {
    try {
      const payload = {
        candidate_id: candidateId,
        ...(fileId && { file_id: fileId }),
      };

      const response = await post(
        VYLABS_BASE_URL,
        GET_RESUME_PRESIGNED_URL,
        payload,
      );

      return response;
    } catch (error) {
      console.error("Error fetching fresh presigned URL:", error);
      throw error;
    }
  };
  useEffect(() => {
    setProgressData((prev) => {
      const next = { ...prev };
      UploadedResumes.forEach((file) => {
        if (!next[file.name]) {
          const initial = Math.random() * 30;
          const maxP = 80 + Math.random() * 10;
          next[file.name] = { progress: initial };
          maxProgressRef.current[file.name] = maxP;
        }
      });
      return next;
    });
  }, [UploadedResumes]);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgressData((prev) => {
        const next = { ...prev };
        UploadedResumes.forEach((file) => {
          if (parsedFiles.some((p) => p.name === file.name)) {
            next[file.name] = { progress: 100, progressColor: "green" };
          } else if (failedFiles.some((f) => f.name === file.name)) {
            next[file.name] = { progress: 100, progressColor: "red" };
          } else if (incompleteFiles.some((i) => i.name === file.name)) {
            next[file.name] = { progress: 100, progressColor: "orange" };
          } else {
            const current = next[file.name]?.progress || 0;
            const maxP = maxProgressRef.current[file.name] || 90;
            const increment = 1 + Math.random() * 4;
            const newProgress = Math.min(current + increment, maxP);
            next[file.name] = {
              progress: newProgress,
              progressColor: "#6665ea",
            };
          }
        });
        return next;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, [UploadedResumes, parsedFiles, failedFiles, incompleteFiles]);

  const handleBacktoUpload = () => {
    if (!isParsingComplete) {
      Toast("warning", "Please wait until all files are processed.");
      return;
    } else {
      resetButtonUsageState();
      setShowResumeParser(false);
      setUploadedResumes([]);
      triggerWebSocketReset();
      setParsedData([]);
      setIncompleteData([]);
      setRunSetId(null);
      setErrorMessages([]);
      setSuccessMessages([]);
      setShowFailedTab(false);
      setParsedFiles([]);
      setFailedFiles([]);
      setIncompleteFiles([]);
      window.location.reload();
    }
  };

  const [rowToDelete, setRowToDelete] = useState(null);

  const confirmDeleteRow = (fileName) => {
    setUploadedResumes((prevData) =>
      prevData.filter((file) => file.name !== fileName),
    );
    setParsedFiles((prev) => prev.filter((file) => file.name !== fileName));
    setFailedFiles((prev) => prev.filter((file) => file.name !== fileName));
    setIncompleteFiles((prev) => prev.filter((file) => file.name !== fileName));
    setRowToDelete(null);
  };

  const getFilteredData = () => {
    if (filterStatus === "Running") {
      return UploadedResumes.filter(
        (file) =>
          !parsedFiles.some((parsed) => parsed.name === file.name) &&
          !failedFiles.some((failed) => failed.name === file.name) &&
          !incompleteFiles.some((incomplete) => incomplete.name === file.name),
      );
    }
    if (filterStatus === "Parsed") {
      return UploadedResumes.filter((file) =>
        parsedFiles.some((parsed) => parsed.name === file.name),
      );
    }
    if (filterStatus === "Failed") {
      return UploadedResumes.filter((file) =>
        failedFiles.some((failed) => failed.name === file.name),
      );
    }
    if (filterStatus === "Incomplete") {
      return UploadedResumes.filter((file) =>
        incompleteFiles.some((incomplete) => incomplete.name === file.name),
      );
    }
    return UploadedResumes;
  };

  const filteredParsedData = getFilteredData();

  const dataNotFoundMessage =
    filterStatus === "Running" && filteredParsedData.length === 0
      ? "No files are currently being processed."
      : filterStatus === "Parsed" && filteredParsedData.length === 0
        ? "No files have been successfully parsed."
        : filterStatus === "Failed" && filteredParsedData.length === 0
          ? "No files have failed parsing."
          : filterStatus === "Incomplete" && filteredParsedData.length === 0
            ? "No files have incomplete parsing."
            : filterStatus === "All" && filteredParsedData.length === 0
              ? "No files uploaded yet."
              : "";

  useEffect(() => {
    const runningFiles = UploadedResumes.filter(
      (file) =>
        !parsedFiles.some((parsed) => parsed.name === file.name) &&
        !failedFiles.some((failed) => failed.name === file.name) &&
        !incompleteFiles.some((incomplete) => incomplete.name === file.name),
    );
    setIsParsingComplete(runningFiles.length === 0);
  }, [
    UploadedResumes,
    parsedFiles,
    failedFiles,
    incompleteFiles,
    setIsParsingComplete,
  ]);

  const staticDataColumns = [
    {
      name: "#",
      selector: (row, index) => <span>{index + 1}</span>,
      width: "100px",
    },
    {
      name: "File Name",
      selector: (row) => (
        <CustomTooltip title={row.name} arrow>
          <span className="parsing-file-name-container">
            <FileIcon fileName={row.name} />
            {row.name}
          </span>
        </CustomTooltip>
      ),
    },
    {
      name: "File Type",
      selector: (row) => {
        const fileExtension = row.name.split(".").pop();
        return (
          <div style={{ textAlign: "center", width: "100%" }}>
            {fileExtension.toUpperCase()}
          </div>
        );
      },
    },
    {
      name: "Status",
      selector: (row) => {
        if (parsedFiles.some((file) => file.name === row.name)) {
          return (
            <div className="parsed-status-container">
              <img
                src={ParsedFilesIcon}
                alt="ParsedFilesIcon"
                className="parsed-icon"
              />
              <span>Parsed</span>
            </div>
          );
        }
        if (failedFiles.some((file) => file.name === row.name)) {
          const errorMessage =
            errorMessages.find((msg) => msg.includes(row.name)) || "Failed";
          return (
            <div className="parsed-status-container">
              <img
                src={failedFilesIcon}
                alt="FailedFilesIcon"
                className="parsed-icon"
              />
              <CustomTooltip title={errorMessage} arrow>
                <span>Failed</span>
              </CustomTooltip>
            </div>
          );
        }
        if (incompleteFiles.some((file) => file.name === row.name)) {
          const errorMessage =
            errorMessages.find((msg) => msg.includes(row.name)) || "Incomplete";
          return (
            <div className="parsed-status-container">
              <img
                src={IncompleteIcon}
                alt="IncompleteFilesIcon"
                className="parsed-icon"
              />
              <CustomTooltip title={errorMessage} arrow>
                <span>Incomplete</span>
              </CustomTooltip>
            </div>
          );
        }
        return (
          <div className="parsed-status-container">
            <DotLoader size={1} borderWidth={5} duration={1.5} />
            <span>Running</span>
          </div>
        );
      },
      width: "150px",
    },
    {
      name: "Progress",
      cell: (row) => {
        let progress = 0;
        let progressColor = "#1a90ff";
        let showPercentage = true;
        if (failedFiles.some((file) => file.name === row.name)) {
          progress = 100;
          progressColor = "red";
          showPercentage = false;
        } else if (parsedFiles.some((file) => file.name === row.name)) {
          progress = 100;
          progressColor = "green";
          showPercentage = true;
        } else if (incompleteFiles.some((file) => file.name === row.name)) {
          progress = 100;
          progressColor = "orange";
          showPercentage = false;
        } else {
          progressColor = "#6665ea";
          progress = Math.round(progressData[row.name]?.progress || 0);
          showPercentage = true;
        }
        return (
          <div className="linear-progress-container">
            <BorderLinearProgressBar
              value={progress}
              progressColor={progressColor}
              sx={{ width: "50%", height: "8px" }}
            />
            {showPercentage && (
              <span style={{ fontSize: "12px" }}>{progress}%</span>
            )}
          </div>
        );
      },
      width: "250px",
    },
    ...(filterStatus === "Parsed"
      ? [
          {
            name: "Candidate Status",
            selector: (row) => {
              const parsedItem = parsedData.find(
                (data) => data.name === row.name,
              );
              const status = (
                parsedItem?.candidate_creation_status || "N/A"
              ).toLowerCase();
              return (
                <span
                  style={{
                    color:
                      status === "created"
                        ? "green"
                        : status === "updated"
                          ? "#ffc100"
                          : "gray",
                    fontSize: "15px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {status.charAt(0).toUpperCase() + status.slice(1)}
                </span>
              );
            },
            width: "180px",
          },
        ]
      : []),
    ...(filterStatus !== "Failed" && filterStatus !== "Running"
      ? [
          {
            name: "Actions",
            // center: true,
            cell: (row) => {
              if (isLoading) {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <DynamicSkeleton
                      variant="text"
                      dimensions={{ width: 120 }}
                    />
                  </div>
                );
              }
              return rowToDelete === row.name ? (
                <DeleteConfirmation
                  onConfirm={() => confirmDeleteRow(row.name)}
                  onCancel={() => setRowToDelete(null)}
                  message={"Are you sure, do you want to delete this resume?"}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                  }}
                  className="action-icons"
                >
                  {parsedFiles.some((file) => file.name === row.name) && (
                    <>
                      <CustomTooltip title="View Resume" arrow>
                        <img
                          src={viewResumeIcon}
                          alt="View Resume"
                          className="parser-table-action-icons"
                          onClick={async () => {
                            const fileData = parsedData.find(
                              (data) => data.name === row.name,
                            );
                            if (fileData && fileData.candidate_id) {
                              try {
                                const presignedUrlResponse =
                                  await getFreshPresignedUrl(
                                    fileData.candidate_id,
                                    fileData.file_id || null,
                                  );

                                const finalUrl =
                                  presignedUrlResponse?.presigned_url;
                                if (finalUrl) {
                                  setResumeName(fileData.name);
                                  setResumeUrl(finalUrl);
                                  setShowResumeModal(true);
                                } else {
                                  if (fileData.presigned_url) {
                                    setResumeName(fileData.name);
                                    setResumeUrl(fileData.presigned_url);
                                    setShowResumeModal(true);
                                  } else {
                                    Toast(
                                      "error",
                                      "Unable to load resume. Please try again.",
                                    );
                                  }
                                }
                              } catch (error) {
                                console.error(
                                  "Error fetching presigned URL:",
                                  error,
                                );
                                if (fileData.presigned_url) {
                                  setResumeName(fileData.name);
                                  setResumeUrl(fileData.presigned_url);
                                  setShowResumeModal(true);
                                } else {
                                  Toast("error", "Failed to load resume.");
                                }
                              }
                            } else {
                              console.error(errorMessages);
                            }
                          }}
                        />
                      </CustomTooltip>
                      <CustomTooltip title="View Candidate" arrow>
                        <img
                          src={viewCandidateIcon}
                          alt="View Candidate"
                          className="parser-table-action-icons"
                          onClick={() => {
                            const fileData = parsedData.find(
                              (data) => data.name === row.name,
                            );
                            if (fileData && fileData.candidate_id) {
                              fetchCandidateById(
                                fileData.candidate_id,
                                "viewCandidate",
                                fileData,
                              );
                            } else {
                              console.error(errorMessages);
                            }
                          }}
                        />
                      </CustomTooltip>
                    </>
                  )}
                  {incompleteFiles.some((file) => file.name === row.name) && (
                    <>
                      <Button
                        label={"Fix"}
                        event={() => handleOpenInviteModal(row)}
                        style={{ padding: "2px 15px" }}
                      />
                    </>
                  )}
                </div>
              );
            },
            width: "200px",
          },
        ]
      : []),
  ];

  const runningFilesCount = UploadedResumes.filter(
    (file) =>
      !parsedFiles.some((parsed) => parsed.name === file.name) &&
      !failedFiles.some((failed) => failed.name === file.name) &&
      !incompleteFiles.some((incomplete) => incomplete.name === file.name),
  ).length;

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const closeModal = async () => {
    setIsModalOpen(false);
    resetCandidateEdit();
    setActiveTab(0);
  };

  useEffect(() => {
    if (!isModalOpen) {
      setActiveTab(null);
    }
  }, [isModalOpen]);

  const fetchFreshPresignedUrlForIncompleteFile = async (fileId) => {
    try {
      if (!fileId) {
        throw new Error("File ID is required");
      }

      const payload = {
        file_id: fileId,
      };

      const response = await post(
        VYLABS_BASE_URL,
        GET_RESUME_PRESIGNED_URL,
        payload,
      );

      return response?.presigned_url || null;
    } catch (error) {
      console.error(
        "Error fetching fresh presigned URL for incomplete file:",
        error,
      );
      throw error;
    }
  };

  const handleOpenInviteModal = async (fileData) => {
    const incompleteFileData = incompleteData.find(
      (data) => data.name === fileData.name,
    );
    if (!incompleteFileData) {
      console.error("No incomplete file data found for:", fileData.name);
      return;
    }

    let parsedResume = {};
    try {
      if (incompleteFileData.parsed_resume) {
        parsedResume =
          typeof incompleteFileData.parsed_resume === "string"
            ? JSON.parse(incompleteFileData.parsed_resume)
            : incompleteFileData.parsed_resume;
      }
    } catch (error) {
      console.error("Error parsing parsed_resume:", error);
    }

    let skills = [];
    if (incompleteFileData.resume_skills) {
      try {
        skills =
          typeof incompleteFileData.resume_skills === "string"
            ? JSON.parse(incompleteFileData.resume_skills)
            : incompleteFileData.resume_skills;
      } catch (e) {
        console.error("Error parsing resume_skills:", e);
        skills = [];
      }
    }

    if ((!skills || skills.length === 0) && parsedResume?.Skills) {
      skills = parsedResume.Skills;
    }

    const prefilledValues = {
      canName:
        incompleteFileData.resume_name || parsedResume?.BasicInfo?.Name || "",
      canEmail:
        incompleteFileData.resume_email || parsedResume?.BasicInfo?.Email || "",
      canLocation: "",
      canMobile:
        incompleteFileData.resume_contact ||
        parsedResume?.BasicInfo?.PhoneNumber ||
        "",
      canSkills: "",
      secondaryPhone: "",
      secondaryEmail: "",
      jobDescription: "",
      askmeanything: "",
      designation: parsedResume?.BasicInfo?.Designation || "",
      vendorID: "",
      skills: Array.isArray(skills) ? skills : [],
    };

    try {
      let freshPresignedUrl = "";
      if (incompleteFileData.id) {
        freshPresignedUrl = await fetchFreshPresignedUrlForIncompleteFile(
          incompleteFileData.id,
        );
      }
      setResumeUrl(freshPresignedUrl || incompleteFileData?.presigned_url);
      setResumeName(incompleteFileData?.name);
      setSelectedIncompleteFileId(incompleteFileData.id);
      setCandidateModal(true);
    } catch (error) {
      console.error("Error in handleOpenInviteModal:", error);
      setResumeUrl(incompleteFileData?.presigned_url || "");
      setResumeName(incompleteFileData?.name);
      setSelectedIncompleteFileId(incompleteFileData.id);
      setCandidateModal(true);
    }
    formik.resetForm({ values: prefilledValues });
    setAutoCompleteKey((prev) => prev + 1);
  };

  const handleCloseInviteModal = () => {
    formik.resetForm();
    setAutoCompleteKey((prev) => prev + 1);
    setSelectedIncompleteFileId(null);
    setCandidateModal(false);
    setVendorList([]);
    setResumeUrl("");
    setResumeName("");
  };

  const handlePhoneInputChange = React.useCallback(
    (phone) => {
      const normalizedPhone = (phone?.startsWith("+") || phone.length === 0) ? phone : `+${phone}`;
      formik.setFieldValue("canMobile", normalizedPhone);
      formik.setFieldTouched("canMobile", true, false);
      formik.validateField("canMobile");
    },
    [formik],
  );

  const handleCreateCandidate = async () => {
    await formik.validateForm();
    if (!formik.isValid || Object.keys(formik.touched).length === 0) {
      formik.setTouched(
        { canName: true, canEmail: true, canMobile: true, skills: true },
        false,
      );
      Toast("error", "Please fill all required fields correctly");
      return;
    }
    try {
      const response = await post(VYLABS_BASE_URL, CCREATE_CAN, {
        name: formik.values.canName,
        email: formik.values.canEmail,
        secondaryEmail: formik.values.secondaryEmail,
        phone: formik.values.canMobile,
        secondaryPhone: formik.values.secondaryPhone,
        skills: formik.values.skills,
        city: formik.values.city,
        state: formik.values.state,
        country: formik.values.country,
        status: "New Profile",
        contactPerson: formik.values.contactPerson,
        contactDesignation: formik.values.contactDesignation,
        designation: formik.values.designation,
        vendorID: formik.values.vendorID,
        fileID: selectedIncompleteFileId,
      });
      if (response.message === "candidate updated") {
        Toast(
          "info",
          `Candidate with email "${formik.values.canEmail}" or phone "${formik.values.canMobile}" already exists. Their information has been updated instead.`,
        );
      } else {
        Toast(
          "success",
          `Candidate "${formik.values.canName}" created successfully`,
        );
      }
      setCandidateModal(false);
      formik.resetForm();
      setSelectedIncompleteFileId(null);
    } catch (error) {
      console.error("Create Candidate response error:", error);
      Toast("error", error?.response?.data);
    }
  };

  const handleEditCandidate = () => {
    const getValidExperience = (value) => {
      const num = Number(value);

      if (isNaN(num)) return "";
      if (num < 0) return 0;
      return num;
    };

    let experienceValue = "";
    const directExp = getValidExperience(
      selectedCandidate?.years_of_experience,
    );

    const parsedExp = getValidExperience(
      selectedCandidate?.parsedResumeData?.BasicInfo?.YearsOfExperience,
    );

    if (directExp !== "") {
      experienceValue = directExp;
    } else if (parsedExp !== "") {
      experienceValue = parsedExp;
    }
    const candidateWithFormattedSkills = {
      ...selectedCandidate,
      name: selectedCandidate.name || selectedCandidate.BasicInfo?.Name || "",
      email:
        selectedCandidate.email || selectedCandidate.BasicInfo?.Email || "",
      secondaryEmail:
        selectedCandidate.secondaryEmail ||
        selectedCandidate.BasicInfo?.secondaryEmail ||
        "",
      phone:
        selectedCandidate.phone ||
        selectedCandidate.BasicInfo?.PhoneNumber ||
        "",
      secondaryPhone:
        selectedCandidate.secondaryPhone ||
        selectedCandidate.BasicInfo?.secondaryPhone ||
        "",
      city:
        selectedCandidate.city ||
        selectedCandidate.BasicInfo?.CurrentLocationCity ||
        "",
      state:
        selectedCandidate.state ||
        selectedCandidate.BasicInfo?.CurrentLocationState ||
        "",
      country:
        selectedCandidate.country ||
        selectedCandidate.BasicInfo?.CurrentLocationCountry ||
        "",
      skills: Array.isArray(selectedCandidate.skills)
        ? selectedCandidate.skills
        : selectedCandidate.parsedResumeData?.Skills || [],
      vendorID:
        selectedCandidate.vendorID ||
        selectedCandidate.BasicInfo?.vendorID ||
        "",
      designation:
        selectedCandidate.designation?.trim() ||
        selectedCandidate.parsedResumeData?.CareerHistory?.JobDetails?.[0]
          ?.JobTitle ||
        "",
      experience: experienceValue,
      lineAddress1:
        selectedCandidate.lineAddress1 ||
        selectedCandidate.BasicInfo?.LineAddress1 ||
        "",
      lineAddress2:
        selectedCandidate.lineAddress2 ||
        selectedCandidate.BasicInfo?.LineAddress2 ||
        "",
      zipCode:
        selectedCandidate.zipCode || selectedCandidate.BasicInfo?.ZipCode || "",
      preferredSalary:
        selectedCandidate.preferredSalary ||
        selectedCandidate.BasicInfo?.PreferredSalary ||
        "",
    };

    setOriginalCandidateData({ ...selectedCandidate });
    setEditedCandidateData(candidateWithFormattedSkills);
    setIsEditingCandidate(true);
    setEmailError("");
    setEmailTouched(false);
  };

  const resetCandidateEdit = () => {
    if (originalCandidateData) {
      setSelectedCandidate(originalCandidateData);
    }
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
    setEmailError("");
    setEmailTouched(false);
  };

  const saveCandidateChanges = async () => {
    if (!editedCandidateData) {
      Toast("error", "No changes to save");
      return;
    }

    const email =
      editedCandidateData.email !== undefined
        ? editedCandidateData.email
        : selectedCandidate.email || "";

    if (!email.trim()) {
      setEmailError("Email is required");
      setEmailTouched(true);
      Toast("error", "Email is required");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      setEmailTouched(true);
      Toast("error", "Please fill all required fields correctly");
      return;
    }
    setEmailError("");
    setEmailTouched(false);
    try {
      const candidateData = { id: selectedCandidate.id };

      Object.keys(editedCandidateData).forEach((key) => {
        const newValue = editedCandidateData[key];
        const oldValue = selectedCandidate[key];

        const isChanged = Array.isArray(newValue)
          ? JSON.stringify(newValue) !== JSON.stringify(oldValue)
          : newValue !== oldValue;

        if (
          isChanged &&
          newValue !== undefined &&
          newValue !== null &&
          newValue !== ""
        ) {
          candidateData[key] = newValue;
        }
      });

      if (Object.keys(candidateData).length === 1) {
        Toast("error", "No changes to save");
        return;
      }

      Object.keys(candidateData).forEach((key) => {
        if (key === "preferredSalary") {
          candidateData[key] = Number(candidateData[key]);
        }
      });

      if (candidateData.experience !== undefined) {
        candidateData.yearsOfExperience = Number(candidateData.experience);
        delete candidateData.experience;
      }

      const response = await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        candidateData,
      );

      if (response) {
        const updatedCandidate = {
          ...selectedCandidate,
          ...candidateData,
        };

        if (
          candidateData.vendorID !== undefined &&
          candidateData.vendorID !== selectedCandidate.vendorID
        ) {
          if (candidateData.vendorID) {
            try {
              const vendorResponse = await get(
                VYLABS_BASE_URL,
                `${GET_VENDOR_DETAILS_BY_ID}?id=${candidateData.vendorID}`,
              );
              updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
              setAssignedVendor(vendorResponse);
            } catch (err) {
              console.error("Error fetching vendor details:", err);
              updatedCandidate.vendorDetails = null;
              setAssignedVendor(null);
            }
          } else {
            updatedCandidate.vendorDetails = null;
          }
        }

        setSelectedCandidate(updatedCandidate);
        setIsEditingCandidate(false);
        setOriginalCandidateData(null);
        setEditedCandidateData(null);
        Toast("success", "Candidate updated successfully");

        if (isAllCandidatesActive) {
          setAllCanList((prev) =>
            prev.map((candidate) =>
              candidate.id === updatedCandidate.id
                ? updatedCandidate
                : candidate,
            ),
          );
        } else {
          setMyCanList((prev) =>
            prev.map((candidate) =>
              candidate.id === updatedCandidate.id
                ? updatedCandidate
                : candidate,
            ),
          );
        }
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      const backendMessage =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string"
          ? error.response.data
          : null) ||
        error.message ||
        "Failed to update candidate";
      Toast("error", backendMessage);
    }
  };

  const handleCandidateChange = (data) => {
    setEditedCandidateData((prev) => {
      const updated = {
        ...prev,
        ...data,
      };
      return updated;
    });
  };

  const handleRetryAllFailedFiles = async () => {
    if (failedFiles.length === 0) {
      Toast("warning", "No failed files to retry");
      return;
    }
    try {
      setFilterStatus("Running");
      const retryingFiles = [...failedFiles];
      setFailedFiles((prev) =>
        prev.filter(
          (file) => !failedFiles.map((f) => f.name).includes(file.name),
        ),
      );
      setErrorMessages((prev) =>
        prev.filter(
          (msg) => !failedFiles.some((file) => msg.includes(file.name)),
        ),
      );
      setUploadedResumes((prev) => {
        const existingNames = new Set(prev.map((f) => f.name));
        const newFiles = failedFiles.filter(
          (file) => !existingNames.has(file.name),
        );
        return [...prev, ...newFiles];
      });
      const willHaveNoFailedFiles = failedFiles.length === retryingFiles.length;
      saveButtonUsageToStorage("retryFailedFiles");
      setRetryButtonUsed(true);
      const success = await handleRetryAllFailed(retryingFiles);
      if (!success) {
        setFailedFiles((prev) => [...prev, ...retryingFiles]);
        setErrorMessages((prev) => [
          ...prev,
          ...retryingFiles.map((file) => `${file.name}: Retry failed`),
        ]);
        saveButtonUsageToStorage("retryFailedFiles", false);
        setRetryButtonUsed(false);
      } else if (willHaveNoFailedFiles) {
        setShowFailedTab(false);
        setFilterStatus("All");
      }
    } catch (error) {
      console.error("Error retrying failed files:", error);
      Toast("error", "Failed to retry files");
    }
  };

  const hasAnyFailedFileBeenRetried = () => {
    return failedFiles.some(
      (file) =>
        failedFileRetryCounts[file.name] &&
        failedFileRetryCounts[file.name] >= 1,
    );
  };

  const shouldShowRetryButton = () => {
    if (retryButtonUsed) return false;
    return !hasAnyFailedFileBeenRetried();
  };

  const shouldShowFeedbackButton = () => {
    if (reportButtonUsed) return false;
    return (
      hasAnyFailedFileBeenRetried() ||
      (retryButtonUsed && failedFiles.length > 0)
    );
  };
  const handleProvideFeedback = async () => {
    try {
      const allFailedFromRetry = Object.values(retryApiResponses).flatMap(
        (response) => response.finalStatus?.failed || [],
      );
      const failedFilesWithUrls = allFailedFromRetry.map((failedFile) => ({
        id: failedFile.id,
        name: failedFile.name,
      }));

      const feedbackData = {
        feedback: {
          screens: [],
          ratings: 0,
          feedback_desc: "Resume Parser Failed Files Report.",
          user: {
            first_name: userDetails?.first_name || "",
            last_name: userDetails?.last_name || "",
            email: userDetails?.email || "",
            user_id: userDetails?.id || "",
          },
          failed_files_urls: failedFilesWithUrls,
          tenant: {
            name: tenantDetails?.name || "",
            id: tenantDetails?.id || "",
          },
        },
      };

      await uploadFeedbackToS3(feedbackData);
      saveButtonUsageToStorage("reportFailedFiles");
      setReportButtonUsed(true);
      Toast("success", "Failed files report submitted successfully!");
    } catch (error) {
      console.error("Error submitting failed files feedback:", error);
      Toast("error", "Failed to submit report. Please try again.");
    }
  };

  const uploadFeedbackToS3 = async () => {
    try {
      const formData = new FormData();

      failedFiles.forEach((file) => {
        formData.append("failed_files", file);
      });

      formData.append(
        "feedback_desc",
        "The following files failed after the reparse attempt.",
      );

      await post(VYLABS_BASE_URL, SEND_FEEDBACK, formData);
      return true;
    } catch (error) {
      console.error("Error uploading feedback to S3:", error);
      throw error;
    }
  };
  useEffect(() => {
    const retryUsed = getButtonUsageFromStorage("retryFailedFiles");
    const reportUsed = getButtonUsageFromStorage("reportFailedFiles");

    setRetryButtonUsed(retryUsed);
    setReportButtonUsed(reportUsed);
  }, []);
  useEffect(() => {
    if (UploadedResumes.length === 0 && failedFiles.length === 0) {
      resetButtonUsageState();
    }
  }, [UploadedResumes, failedFiles]);
  const saveButtonUsageToStorage = (buttonType) => {
    try {
      const currentUsage = JSON.parse(
        localStorage.getItem(BUTTON_USAGE_KEY) || "{}",
      );
      currentUsage[buttonType] = {
        used: true,
        timestamp: Date.now(),
      };
      localStorage.setItem(BUTTON_USAGE_KEY, JSON.stringify(currentUsage));
    } catch (error) {
      console.error("Error saving button usage to storage:", error);
    }
  };

  const getButtonUsageFromStorage = (buttonType) => {
    try {
      const usageData = JSON.parse(
        localStorage.getItem(BUTTON_USAGE_KEY) || "{}",
      );
      return usageData[buttonType]?.used || false;
    } catch (error) {
      console.error("Error reading button usage from storage:", error);
      return false;
    }
  };

  const clearButtonUsageFromStorage = () => {
    try {
      localStorage.removeItem(BUTTON_USAGE_KEY);
    } catch (error) {
      console.error("Error clearing button usage from storage:", error);
    }
  };
  const resetButtonUsageState = () => {
    clearButtonUsageFromStorage();
    setRetryButtonUsed(false);
    setReportButtonUsed(false);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      resetButtonUsageState();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="header-and-resume-button-container">
        <div className="upload-parser-resume-header">
          {showHeader && (
            <div className="header-parser-main-container">
              <div className="header-icon-title-container">
                <img
                  alt=""
                  src={isDarkMode ? RPHeaderDarkIcon : RPHeaderLightIcon}
                  className="header-title-icon"
                />
                <h2>Resume Parser</h2>
              </div>
              <div className="right-side-button-container">
                <Button
                  className="import-action-buttons"
                  label="Back to Upload"
                  iconSrc={uploadIcon}
                  event={handleBacktoUpload}
                />
              </div>
            </div>
          )}
        </div>

        <div className="resume-button-container">
          <div className="left-side-button-container">
            <Button
              label="All Files"
              iconSrc={isDarkMode ? allFilesDarkIcon : allFilesIcon}
              event={() => setFilterStatus("All")}
              style={{
                border: filterStatus === "All" ? "1px solid #6860ee" : "",
                backgroundColor:
                  filterStatus === "All"
                    ? "var(--table_header_backgroundcolor)"
                    : "",
                color: filterStatus === "All" ? "var(--header__color)" : "",
              }}
              fileCountbackgroundColor="#EDEDED"
              fileCountColor="black"
              fileCount={UploadedResumes.length}
              className="parser-action-buttons"
              iconWidth="20px"
            />
            <Button
              label="Running"
              iconSrc={runningFilesIcon}
              event={() => setFilterStatus("Running")}
              style={{
                border: filterStatus === "Running" ? "1px solid #6860ee" : "",
                backgroundColor:
                  filterStatus === "Running"
                    ? "var(--table_header_backgroundcolor)"
                    : "",
                color: filterStatus === "Running" ? "var(--header__color)" : "",
              }}
              fileCount={runningFilesCount}
              className="parser-action-buttons"
              iconWidth="20px"
            />
            <Button
              label="Parsed"
              iconSrc={ParsedFilesIcon}
              event={() => setFilterStatus("Parsed")}
              style={{
                border: filterStatus === "Parsed" ? "1px solid #6860ee" : "",
                backgroundColor:
                  filterStatus === "Parsed"
                    ? "var(--table_header_backgroundcolor)"
                    : "",
                color: filterStatus === "Parsed" ? "var(--header__color)" : "",
              }}
              fileCount={parsedFiles.length}
              fileCountbackgroundColor="green"
              fileCountColor="white"
              className="parser-action-buttons"
              iconWidth="20px"
            />
            <Button
              label="Incomplete"
              iconSrc={IncompleteIcon}
              event={() => setFilterStatus("Incomplete")}
              style={{
                border:
                  filterStatus === "Incomplete" ? "1px solid #6860ee" : "",
                backgroundColor:
                  filterStatus === "Incomplete"
                    ? "var(--table_header_backgroundcolor)"
                    : "",
                color:
                  filterStatus === "Incomplete" ? "var(--header__color)" : "",
              }}
              fileCount={incompleteFiles.length}
              fileCountbackgroundColor="orange"
              fileCountColor="white"
              className="parser-action-buttons"
              iconWidth="20px"
            />
            {(showFailedTab || failedFiles.length > 0) && (
              <Button
                label="Failed"
                iconSrc={failedFilesIcon}
                event={() => setFilterStatus("Failed")}
                style={{
                  border: filterStatus === "Failed" ? "1px solid #6860ee" : "",
                  backgroundColor:
                    filterStatus === "Failed"
                      ? "var(--table_header_backgroundcolor)"
                      : "",
                  color:
                    filterStatus === "Failed" ? "var(--header__color)" : "",
                }}
                fileCount={failedFiles.length}
                fileCountbackgroundColor="red"
                fileCountColor="white"
                className="parser-action-buttons"
                iconWidth="20px"
              />
            )}
            {filterStatus === "Failed" && failedFiles.length > 0 && (
              <>
                {shouldShowRetryButton() && (
                  <CustomTooltip
                    title={"All of the failed files can be parsed again."}
                  >
                    <Button
                      label="Retry Failed Files"
                      event={handleRetryAllFailedFiles}
                      style={{
                        backgroundColor: "#6860ee",
                        color: "white",
                        marginLeft: "10px",
                      }}
                      className="parser-action-buttons"
                    />
                  </CustomTooltip>
                )}

                {shouldShowFeedbackButton() && (
                  <CustomTooltip title="Send failed files report to developers">
                    <Button
                      label="Report Failed Files"
                      event={handleProvideFeedback}
                      style={{
                        backgroundColor: "#ff9800",
                        color: "white",
                        marginLeft: "10px",
                      }}
                      className="parser-action-buttons"
                    />
                  </CustomTooltip>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="main-resume-container">
        <div className="table-container">
          <Table
            key={filterStatus}
            columns={staticDataColumns}
            data={filteredParsedData}
            pagination
            highlightOnHover
            fixedHeader
            fixedHeaderScrollHeight="600px"
            dataNotFoundMessage={dataNotFoundMessage}
            clearSelectedRows={false}
            backgroundColor="var(--body__background)"
            color="var(--header__color)"
          />
        </div>
      </div>
      <SidePopup
        key={selectedCandidate?.id || "no-candidate"}
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Candidate Details"
        showDeleteButton={false}
      >
        <CandidateDetailsContainer
          selectedCandidate={selectedCandidate}
          isEditingCandidate={isEditingCandidate}
          editedCandidateData={editedCandidateData}
          setEditedCandidateData={setEditedCandidateData}
          handleEditCandidate={handleEditCandidate}
          resetCandidateEdit={resetCandidateEdit}
          saveCandidateChanges={saveCandidateChanges}
          emailError={emailError}
          emailTouched={emailTouched}
          setEmailError={setEmailError}
          setEmailTouched={setEmailTouched}
          handleCandidateChange={handleCandidateChange}
          candidate={selectedCandidate}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          hasSearched={hasSearched}
          assignedVendor={assignedVendor}
        />
      </SidePopup>
      <SidePopup
        isOpen={candidateModal}
        onClose={handleCloseInviteModal}
        title="Create Candidate"
        sidePopupWidth={"80%"}
      >
        <div
          className="create-candidate-popup-outer"
          style={{ overflowY: "auto", maxHeight: "100%" }}
        >
          <div className="resume-viewer">
            <ResumeViewer url={resumeUrl} name={resumeName} />
          </div>
          <div className="client-popup-container" style={{ width: "60%" }}>
            <div className="form-group">
              <DynamicTextField
                label="Full Name"
                type="text"
                name="canName"
                placeholder="e.g. Alicia Carter"
                value={formik.values.canName}
                onChange={formik.handleChange}
                onBlur={() => formik.setFieldTouched("canName", true)}
                error={formik.touched.canName && formik.errors.canName}
                errorMessage={formik.errors.canName}
                style={{ width: "100%" }}
                required={true}
                labelStyle={{ marginBottom: "15px" }}
              />
              <DynamicTextField
                label="Email"
                type="email"
                name="canEmail"
                placeholder="e.g. alicia.carter@email.com"
                value={formik.values.canEmail}
                onChange={formik.handleChange}
                onBlur={() => formik.setFieldTouched("canEmail", true)}
                error={formik.touched.canEmail && formik.errors.canEmail}
                errorMessage={formik.errors.canEmail}
                style={{ width: "100%" }}
                required={!formik.values.canMobile}
                labelStyle={{ marginBottom: "15px" }}
              />
            </div>

            <div className="form-group">
              <PhoneNumberInput
                value={formik.values.canMobile}
                onChange={handlePhoneInputChange}
                onBlur={() => formik.setFieldTouched("canMobile", true)}
                error={formik.errors.canMobile}
                touched={formik.touched.canMobile}
                placeholder="e.g. (415) 555-0198"
                label="Contact No."
                width="100%"
                height="40px"
                countryListWidth="300px"
                phoneContainerStyle={{ marginBottom: "15px" }}
                required={!formik.values.canEmail}
              />
            </div>

            <div className="form-group">
              <label htmlFor="title" className="textfield-label">
                Skills <span className="required-asterisk">*</span>
              </label>
              <AutoComplete
                key={`auto-complete-${autoCompleteKey}`}
                multiple
                placeholder="e.g. JavaScript, React, Node.js"
                options={skills.filter((skill) => {
                  const selectedSkills = Array.isArray(formik.values.skills)
                    ? formik.values.skills
                    : [];
                  return !selectedSkills.some(
                    (selectedSkill) =>
                      selectedSkill.toLowerCase() === skill.title.toLowerCase(),
                  );
                })}
                tags={true}
                name="canSkills"
                style={{ marginTop: "15px !important" }}
                value={formik.values.skills || []}
                onChange={(selectedOptions) => {
                  const validSkills = selectedOptions
                    .map((option) =>
                      typeof option === "string" ? option : option.title,
                    )
                    .filter((option) => option.trim() !== "");

                  const uniqueSkills = validSkills.filter(
                    (skill, index, self) =>
                      index ===
                      self.findIndex(
                        (s) => s.toLowerCase() === skill.toLowerCase(),
                      ),
                  );

                  formik.setFieldValue("skills", uniqueSkills);
                }}
                onBlur={() => formik.setFieldTouched("skills", true)}
                InputWrapperStyle={{
                  height: "100px",
                  overflowY: "auto",
                  padding: "10px",
                  marginBottom: "30px",
                  marginTop: "15px",
                }}
                showClearAll={true}
                error={formik.touched.skills && formik.errors.skills}
                errorMessage={formik.errors.skills}
              />
            </div>
            <div className="form-group">
              <DynamicTextField
                label="Designation"
                type="text"
                name="designation"
                placeholder="e.g. Software Engineer"
                value={formik.values.designation}
                onChange={formik.handleChange}
                onBlur={() => formik.setFieldTouched("designation", true)}
                error={formik.touched.designation && formik.errors.designation}
                errorMessage={formik.errors.designation}
                style={{ width: "100%" }}
                required={false}
                labelStyle={{ marginBottom: "15px" }}
              />
            </div>
            {isVendorFeatureEnabled && (
              <div className="form-group">
                <label htmlFor="vendorID" className="textfield-label">
                  Vendor (Optional)
                </label>
                <DynamicAutocomplete
                  key={`autocomplete-vendor-${
                    formik.values.vendorID || "empty"
                  }`}
                  onChange={(value) => {
                    formik.setFieldValue("vendorID", value?.value || "");
                    if (!value) {
                      setVendorList([]);
                    }
                  }}
                  value={
                    formik.values.vendorID
                      ? vendorList.find(
                          (vendor) => vendor.value === formik.values.vendorID,
                        ) || null
                      : null
                  }
                  placeholder={"Select Vendor"}
                  minCharsForSearch={3}
                  noOptionsText="No Vendor found."
                  onInputChange={handleVendorInputChange}
                  options={vendorList}
                  loading={vendorOptionLoading}
                  sx={{
                    mt: "5px",
                    ".MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      height: "40px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid var(--border__color) !important",
                        borderRadius: "12px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6860ee",
                        borderRadius: "12px",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#7a70f2",
                        borderRadius: "12px",
                      },
                    },
                    ".MuiInputBase-input": {
                      color: "var(--header__color)",
                      padding: "8px 12px !important",
                      height: "40px",
                      fontFamily: "Satoshi !important",
                    },
                  }}
                  slotProps={{
                    paper: {
                      sx: {
                        backgroundColor: "var(--body__background)",
                        color: "var(--header__color)",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                        border: "1px solid var(--border__color)",
                      },
                    },
                    listbox: {
                      sx: {
                        "& li": {
                          fontSize: "14px",
                          fontWeight: 500,
                          padding: "8px 16px",
                          color: "var(--header__color)",
                          "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.04)",
                          },
                        },
                      },
                    },
                  }}
                />
              </div>
            )}

            <div className="create-client-button-container">
              <Button
                label="Cancel"
                event={handleCloseInviteModal}
                backgroundColor="#6860ee"
                isCancel={true}
              />
              <Button
                label="Create Candidate"
                event={handleCreateCandidate}
                backgroundColor="#6860ee"
              />
            </div>
          </div>
        </div>
      </SidePopup>
      {showResumeModal && (
        <ResumeViewerModal
          url={resumeUrl}
          name={resumeName}
          onClose={() => setShowResumeModal(false)}
          isOpen={showResumeModal}
        />
      )}
    </>
  );
}

export default ResumeParser;
